// @flow
import React from 'react';
import { List, ListItem } from 'material-ui/List';
import Version from '../version/Version';
import BaseMenuItem from 'material-ui/MenuItem';
import Drawer from 'material-ui/Drawer';
import { NavLink, withRouter } from 'react-router-dom';
import NestingMenuItem from '../nested-menu/nesting-menu-item';
import { sectionPath } from '../../lib/config';
//ICONS
import NewsIcon from 'material-ui/svg-icons/action/receipt';
import ArticleIcon from 'material-ui/svg-icons/action/reorder';
import BlocksIcon from 'material-ui/svg-icons/content/select-all';
import Settings from 'material-ui/svg-icons/action/settings-applications';
import SubscriptionsIcon from 'material-ui/svg-icons/av/subscriptions';
import TVIcon from 'material-ui/svg-icons/hardware/tv';
import PersonIcon from 'material-ui/svg-icons/social/person';
import DNSIcon from 'material-ui/svg-icons/action/dns';
import InserIcon from 'material-ui/svg-icons/action/compare-arrows';
// import Icon from '../ui/icon/icon';
import IconImage from 'material-ui/svg-icons/image/image';
import IconChart from 'material-ui/svg-icons/editor/insert-chart';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import { useAppContext } from '../../AppContext';

type SidebarMenuProps = {
	drawerWidth: Number,
	pathname: String,
};

const menu = [
	{
		title: 'Новости',
		icon: <NewsIcon />,
		link: `/articles/${sectionPath.news}`,
	},
	{
		title: 'Статьи',
		icon: <ArticleIcon />,
		link: `/articles/${sectionPath.article}`,
	},
	{
		title: 'Фотографии',
		icon: <IconImage />,
		link: '/image',
	},
	{
		title: 'Видео',
		icon: <SubscriptionsIcon />,
		link: '/video',
	},
	{
		title: 'Бегущая строка',
		icon: <InserIcon />,
		link: `/info-strings/`,
	},
	{
		title: 'Блоки',
		icon: <BlocksIcon />,
		nestedRoutes: [
			{
				title: 'Главные блоки',
				icon: <BlocksIcon />,
				link: `/configurable-blocks/`,
			},
			{
				title: 'Переменные',
				icon: <ArticleIcon />,
				link: `/vocabulary/`,
			},
			{
				title: 'ТВ-программа',
				icon: <TVIcon />,
				link: '/epg',
			},
		],
	},
	{
		title: 'Системный',
		icon: <Settings />,
		nestedRoutes: [
			{
				title: 'Загрузка файлов',
				icon: <ArticleIcon />,
				link: `/system-settings/`,
				isPrivate: true,
			},
			{
				title: 'Статистика',
				icon: <IconChart />,
				link: '/stats',
			},

			{
				title: 'Пользователи',
				icon: <PersonIcon />,
				link: '/users',
				isPrivate: true,
			},
		],
	},
	{
		title: 'Справочники',
		icon: <ArticleIcon />,
		nestedRoutes: [
			{
				title: 'Псевдонимы',
				icon: <PersonIcon />,
				link: '/people',
			},
			{
				title: 'Темы',
				icon: <DNSIcon />,
				link: '/topics',
			},
			{
				title: 'Рубрики',
				icon: <DNSIcon />,
				link: `/categories/${sectionPath.news}`,
			},
			{
				title: 'Программы',
				icon: <DNSIcon />,
				link: '/shows',
			},
		],
	},
];

const MenuItem = withRouter(({ title, link, icon, pathname, history }) => (
	<ListItem
		primaryText={title}
		leftIcon={icon}
		containerElement={<NavLink to={link} activeClassName="sidebar-item__active" />}
		isKeyboardFocused={pathname.startsWith(link)}
		onClick={() => history.push(link)}
	/>
));

export const SidebarMenu = (props: SidebarMenuProps) => {
	const { drawerWidth, pathname } = props;
	const { isAdmin } = useAppContext();
	return (
		<Drawer
			open
			docked
			zIndex={0}
			containerStyle={{
				width: drawerWidth,
				height: 'calc(100% - 64px)',
				top: 64,
				paddingTop: 34,
				boxShadow: 'none',
			}}
		>
			<List>
				{menu
					.filter(({ isPrivate }) => (isPrivate && isAdmin) || typeof isPrivate === 'undefined')
					.map(item => {
						if (item.nestedRoutes) {
							const subMenus = item.nestedRoutes
								.filter(({ isPrivate }) => (isPrivate && isAdmin) || typeof isPrivate === 'undefined')
								.map((subItem, index) => (
									<ListItem
										key={`subMenu_${index}`}
										leftIcon={subItem.icon}
										containerElement={<NavLink to={subItem.link} activeClassName="sidebar-item__active" />}
										primaryText={subItem.title}
									/>
								));
							return (
								<NestingMenuItem
									menuItems={subMenus}
									key={item.link}
									leftIcon={item.icon}
									rightIcon={<ArrowDropDown style={{ transform: 'rotate(-90deg)' }} />}
									primaryText={item.title}
								/>
							);
						}
						return <MenuItem key={item.link} {...item} pathname={pathname} />;
					})}
			</List>
			{props.children}
			<Version />
		</Drawer>
	);
};



// WEBPACK FOOTER //
// src/components/sidebar-menu/sidebar-menu.jsx